import { getDetailExperience } from 'services/apis/detail-experience-api';
import { GET_DETAIL_EXPERIENCE_ITEMS } from 'constants/detail-experience';

export const getDetailExperienceAction = (id) => ({
  type: GET_DETAIL_EXPERIENCE_ITEMS,
  payload: getDetailExperience(id),
});
